import axios from "axios";

const BASE_URL = process.env.DETRAN_API_URL ?? "";

const httpClientGateway = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "App-Key": process.env.APP_KEY ?? "",
  },
});

export default httpClientGateway;
